import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c031dfce&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c031dfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c031dfce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c031dfce')) {
      api.createRecord('c031dfce', component.options)
    } else {
      api.reload('c031dfce', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c031dfce&scoped=true&", function () {
      api.rerender('c031dfce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wzB0OfmWKfbB/JS/comp/GuestBox.vue"
export default component.exports